import React from 'react';
import Invoices from './Invoices';

const Estimates = () => <Invoices variant="estimates" />;

export default Estimates;
